export default __webpack_public_path__ + "static/media/ktcl_04.f23ab222.png";